function meta(name: string): string {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? "";
}

export const GOOGLE_CLIENT_ID = meta("google-client-id");
export const GOOGLE_HOSTED_DOMAIN = meta("google-hosted-domain");
export const CSRF_TOKEN = meta("csrf-token");
